import { useEffect, useState } from 'react'

/** The shell switches from the left rail to the phone layout below this width. */
export const DESKTOP_QUERY = '(min-width: 900px)'

function matchOrFalse(query: string): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(query).matches
    : false
}

/**
 * Tracks a CSS media query, updating on viewport/theme changes. SSR-safe and false where
 * matchMedia is missing (jsdom), unless `fallback` says otherwise.
 */
export function useMediaQuery(query: string, fallback = false): boolean {
  const supported = typeof window !== 'undefined' && typeof window.matchMedia === 'function'
  const [matches, setMatches] = useState(() => (supported ? matchOrFalse(query) : fallback))

  useEffect(() => {
    if (!supported) return
    const mql = window.matchMedia(query)
    const onChange = () => setMatches(mql.matches)
    onChange()
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [query, supported])

  return matches
}

/** True on the desktop layout; true in jsdom too, so tests render the full desktop chrome. */
export function useIsDesktop(): boolean {
  return useMediaQuery(DESKTOP_QUERY, true)
}
